import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      navigate("/rooms");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid md:grid-cols-2 gap-16 items-center">
      <div className="hidden md:block">
        <span className="hanko text-primary text-4xl">入</span>
        <h1 className="font-serif font-light text-5xl lg:text-6xl tracking-tighter mt-6 leading-[0.95]">
          Enter the<br />quiet house.
        </h1>
        <p className="mt-6 text-muted-foreground max-w-sm">
          Return to the rooms where your verses wait, linked among fellow poets.
        </p>
      </div>

      <div className="max-w-md w-full">
        <h2 className="font-serif text-3xl mb-8">Enter</h2>
        <form onSubmit={submit} className="space-y-6" data-testid="login-form">
          <div>
            <label className="block text-xs uppercase tracking-widest text-muted-foreground mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="login-email"
              className="w-full bg-transparent border border-border px-4 py-3 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-widest text-muted-foreground mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="login-password"
              className="w-full bg-transparent border border-border px-4 py-3 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors"
            />
          </div>
          {error && (
            <p data-testid="login-error" className="text-sm text-primary">{error}</p>
          )}
          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit"
            className="w-full bg-primary text-primary-foreground py-3 text-sm tracking-wide hover:-translate-y-0.5 transition-transform disabled:opacity-50"
          >
            {busy ? "Entering…" : "Enter"}
          </button>
        </form>
        <p className="mt-6 text-sm text-muted-foreground">
          No account yet?{" "}
          <Link to="/register" data-testid="link-register" className="text-primary border-b border-primary/40">
            Join the house
          </Link>
        </p>
      </div>
    </div>
  );
}
